module.exports = __webpack_public_path__ + "img/alumni.bbd0bb20.jpg";